import * as tslib_1 from "tslib";
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./OptionsPaneError.scss');
var OptionsPaneError = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneError, _super);
    function OptionsPaneError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneError.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", { className: strings.optionsFull_subCategory_error })));
    };
    return OptionsPaneError;
}(React.Component));
export default OptionsPaneError;
//# sourceMappingURL=OptionsPaneError.js.map